<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4 mt-2">
          <span v-if="!isEditing">Add</span>
          <span v-else>Edit</span> Income Receipt Settings
        </h1>
        <h4 class="text-left mx-4" v-if="receiptSettingsData.is_used">
          Cannot be edited since Finance Transactions are already made using this Income Receipt Settings
        </h4>
      </v-col>
      <v-col cols="12" md="4" class="text-right">
        <v-btn
          v-if="isEditing"
          @click="showDeleteConfirmation = true"
          color="red"
          class="my-2 mr-8"
          rounded
          :disabled="receiptSettingsData.is_used"
          outlined
          >Delete</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="mx-2 mb-2">
          <!-- form starts here -->
          <v-form v-model="submitForm" @submit.prevent="submitReceiptData()">
            <v-row class="my-1">
              <v-col cols="4">
                <p class="text-left mx-2 mb-1">
                  Title
                  <span class="required"></span>
                </p>
                <v-text-field
                  v-model="receiptSettingsData.title"
                  outlined
                  dense
                  class="rounded-input mx-3"
                  :rules="[rules.required, rules.title]"
                  hide-details="auto"
                  maxlength="55"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-1">
              <v-col cols="12">
                <h3 class="text-left mx-5">Receipt Number</h3>
              </v-col>
            </v-row>

            <!-- prefix input -->
            <v-row>
              <v-col cols="12" md="4" sm="4">
                <v-text-field
                  outlined
                  dense
                  class="mx-3 rounded-input"
                  label="Prefix"
                  v-model="receiptSettingsData.prefix"
                  maxlength="20"
                ></v-text-field>
              </v-col>

              <!-- value input -->
              <v-col cols="12" md="4" sm="4">
                <v-text-field
                  outlined
                  dense
                  class="mx-3 rounded-input"
                  label="Auto-incrementing Value"
                  type="number"
                  min="0"
                  :rules="[rules.notEmptyNumber]"
                  v-model="receiptSettingsData.value"
                ></v-text-field>
              </v-col>

              <!-- suffix input -->
              <v-col cols="12" md="4" sm="4">
                <v-text-field
                  outlined
                  dense
                  class="mx-3 rounded-input"
                  label="Suffix"
                  v-model="receiptSettingsData.suffix"
                  maxlength="20"
                ></v-text-field>
              </v-col>
            </v-row>

            <!--show receipt number to be generated  -->
            <v-row class="mb-2">
              <v-col cols="12" md="6" sm="8">
                <div class="mx-5 font-weight-medium text-left">
                  Next Receipt Number:
                  <span class="font-weight-bold">
                    {{ receiptSettingsData.prefix
                    }}{{ receiptSettingsData.value
                    }}{{ receiptSettingsData.suffix }}
                  </span>
                </div>
              </v-col>
            </v-row>

            <div class="header-content-editor mb-2">
              <v-container>
                <h3 class="text-left">Header Content</h3>
                <div class="quill-editor">
                  <quill
                    :content="receiptSettingsData.header_content"
                    class="editor"
                    :options="editorOption"
                    @change="onEditorChange($event)"
                  >
                  </quill>
                </div>
              </v-container>
            </div>

            <!-- upload font image -->
            <v-row class="mx-2" justify="end">
              <v-col cols="4" sm="6" align-self="center">
                <h3 class="text-left">Font Image</h3>
              </v-col>

              <v-spacer></v-spacer>
              <!-- image input -->
              <v-col cols="8" sm="6" class="text-right" align-self="center">
                <input
                  type="file"
                  name="upload"
                  id="upload"
                  @change="studentImageCallback($event)"
                  accept="image/*"
                />
                <label class="new-button mr-3" for="upload">
                  Upload Image
                </label>
              </v-col>
            </v-row>

            <v-row class="mx-2 mb-2">
              <v-col>
                <div id="preview" v-if="imgUrl">
                  <img :src="imgUrl" alt="Font Image Preview" />
                </div>
                <div v-else-if="receiptSettingsData.font_image" id="previous">
                  <img
                    :src="receiptSettingsData.font_image"
                    alt="Stored Image Preview"
                  />
                </div>
                <div v-else>
                  <h1>
                    {{ currentInstitution.name }}
                  </h1>
                </div>
                <div v-if="!imgUrl">
                  <small>Image aspect ratio must be 6:1</small>
                </div>
              </v-col>
            </v-row>

            <div class="note-settings">
              <v-container>
                <h3 class="text-left mx-2">Income Receipt Notes</h3>
                <v-row>
                  <v-col cols="12">
                    <div class="quill-editor">
                      <quill
                        :content="receiptSettingsData.notes"
                        class="editor"
                        :options="editorOption"
                        @change="onNotesChange($event)"
                      >
                      </quill>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="receiptSettingsData.hide_received_by"
                      label="Hide received by on income receipt."
                      hide-details="auto"
                      class="mx-4"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-container>
            </div>

            <!-- <v-row>
              <v-col>
                <h3 class="text-left mx-5">Income Receipt Notes</h3>
                <p class="font-text-medium text-left mx-5 my-1">
                  If entered, these will be displayed on the bottom of the
                  generated income receipt.
                </p>
              </v-col>
            </v-row>

             receipt notes input -->
            <!-- <v-row>
              <v-col cols="12">
                <v-textarea
                  outlined
                  class="mx-5"
                  placeholder="Income Receipt Notes"
                  v-model="receiptSettingsData.notes"
                >
                </v-textarea>
              </v-col>
            </v-row>  -->

            <!-- receipt options -->
            <!-- <v-row>
							<v-col>
								<h3 class="text-left mx-5">Payslip Options</h3>
							</v-col>
						</v-row> -->

            <!-- row for data table -->
            <!-- <v-row justify="center">
							<v-col cols="8" align-self="center">
								<v-card class="mt-2">
									<v-data-table :headers="optionHeaders" :items="options" hide-default-footer disable-pagination>
										<template v-slot:item.enable="{ item }">
												<div class="centered-switch">
												<v-switch
														inset
														v-model="item.enable"
												>
												</v-switch>
												</div>
										</template>
									</v-data-table>
								</v-card>
							</v-col>
							
						</v-row> -->

            <!-- action buttons -->
            <v-row>
              <v-col>
                <div class="text-right mx-4 my-4">
                  <v-btn
                    class="mr-4"
                    color="red"
                    :to="{ name: 'FinanceSettings' }"
                    rounded
                    outlined
                  >
                    Cancel
                  </v-btn>
                  <!-- Removed disabled from submit button :disabled="isLoading || !submitForm" -->
                  <v-btn
                    color="primary"
                    type="submit"
                    rounded
                    v-model="submitForm"
                    :disabled="isLoading || !submitForm"
                  >
                    Submit
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible">
      <span>{{ snackbar.text }}</span>
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
    <DeleteConfirmationDialog
      title="Are you sure you want to delete this Income Receipt Settings?"
      :visible="showDeleteConfirmation"
      @deleteObject="deleteObjectConfirmation"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc.js";
import { quillEditor } from "vue-quill-editor";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  name: "AddEditIncomeReceiptSettings",

  components: {
    quill: quillEditor,
    DeleteConfirmationDialog,
  },

  data() {
    return {
      isEditing: false,
      moment: moment,
      rules: {
        title: (v) => /^[a-zA-Z0-9_ ]{1,55}$/.test(v) || "Invalid",
        required: (v) => !!v || "Required",
        notEmptyNumber: (v) => v >= 0 || "Invalid",
      },
      snackbar: {
        visible: false,
        text: "",
      },
      submitForm: false,
      imgUrl: null, // url of selected img file
      imgfile: null, // img file in base64 format

      // receipt option headers
      // optionHeaders: [
      // 	{ text: "Option", value: "option", sortable: false },
      // 	{ text: "Enable", value: "enable", align:"center"}
      // ],

      // dummy payslip options
      // options: [
      // 	{ option: 'Show Attendance Details', enable: true },
      // 	{ option: 'Show Bank Details', enable: true },
      // 	{ option: 'Show Payslip Number', enable: false },
      // 	{ option: 'Show Amount in Words', enable: true },
      // 	{ option: 'Show Signature Fields', enable: true }
      // ],

      receiptSettingsData: {
        // v-model for all fields and file
        prefix: null,
        value: 0,
        suffix: null,
        notes: null,
        font_image: null,
        institution: null,
      },
      headerQuillObj: { delta: null, html: null },
      notesQuillObj: { delta: null, html: null },
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },

      showDeleteConfirmation: false,

      // receiptSettingsOptions: {}		// store receipt options here
    };
  },

  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution",
    ]),

    apiEssentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    // handle api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // fetch receipt data via api
    async getReceiptData() {
      var url =
        endpoints.financeReceiptSettings +
        `${this.$route.params.receipt_settings_id}/`;
      url = Helper.addUrlParams(url, "show_used=true");
      var response = await api.call(this.apiEssentials, url);

      if (response) {
        this.receiptSettingsData = response;
      }
    },

    // select img file and convert to a shareable format
    async studentImageCallback(e) {
      if (!e.target.files[0]) return;
      let tempImg = e.target.files[0];
      let img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = async () => {
        if (img.width == 6 * img.height) {
          this.imgUrl = URL.createObjectURL(tempImg);
          this.imgfile = await Helper.toBase64(tempImg);
          this.receiptSettingsData.font_image = this.imgfile;
        } else {
          this.snackbar.text = `Image aspect ratio must be 6:1`;
          this.snackbar.visible = true;
        }
      };
    },

    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.receiptSettingsData.header_content = html;
      this.headerQuillObj.delta = quill.editor.delta;
      this.headerQuillObj.html = html;
    },
    onNotesChange({ quill, html, text }) {
      console.log("note change!", quill, html, text);
      this.receiptSettingsData.notes = html;
      this.notesQuillObj.delta = quill.editor.delta;
      this.notesQuillObj.html = html;
    },

    // submit settings data via api call
    async submitReceiptData() {
      var url =
        endpoints.financeReceiptSettings +
        (this.isEditing ? `${this.$route.params.receipt_settings_id}/` : "");
      console.log(url);
      this.receiptSettingsData["headerQuillObj"] = this.headerQuillObj;
      this.receiptSettingsData["notesQuillObj"] = this.notesQuillObj;
      var post_body = this.receiptSettingsData;
      var response = await api.call(
        this.apiEssentials,
        url,
        this.isEditing ? api.Methods.PUT : api.Methods.POST,
        post_body
      );

      if (response) {
        this.snackbar.text = "Receipt Settings updated successfully!";
        this.snackbar.visible = true;
        setTimeout(() => {
          this.$router.push({ name: "AllIncomeReceiptSettings" });
        }, 1000);
      }
    },
    async deleteObjectConfirmation(confirm) {
      this.showDeleteConfirmation = false;
      if (confirm) {
        var url =
          endpoints.financeReceiptSettings +
          `${this.$route.params.receipt_settings_id}/`;

        console.log(url)
        var response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
        if (response == true) {
          this.snackbar.text = "Income Receipt Settings successfully deleted";
          this.snackbar.visible = true;
          this.$router.push({ name: "AllIncomeReceiptSettings" });
        }
      }
    },
  },

  created() {
    this.receiptSettingsData.institution = this.currentInstitution.id;
    this.isEditing = this.$route.params.receipt_settings_id != null;
    if (this.isEditing) this.getReceiptData(); // fetch receipts data for current institute if available
  },
};
</script>

<style>
.centered-switch {
  display: flex;
  justify-content: center;
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#previous {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  height: auto;
}

#previous img {
  max-width: 100%;
  height: auto;
}

#upload {
  display: none;
}

.new-button {
  display: inline-block;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #005b53;
  font-size: 0.875rem;
  color: white;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  text-indent: 0.0892857143em;
  white-space: nowrap;
}
</style>
